import { render } from "./SelectionChatBaseLayout.vue?vue&type=template&id=ba6500d2"
import script from "./SelectionChatBaseLayout.vue?vue&type=script&lang=js"
export * from "./SelectionChatBaseLayout.vue?vue&type=script&lang=js"
script.render = render

export default script